
















































import { Component, Vue,Prop,Watch } from "vue-property-decorator";

@Component({})
export default  class DispalyRules extends Vue  {

  @Prop(String)
  label!:string

  @Prop(Array)
  urls!:any

  @Prop(Array)
  urlParts!:any

  @Prop(Boolean)
  disabled!:boolean

  show = false

  beequaltoUrls = JSON.parse(JSON.stringify(this.urls||[]));
  containUrlParts = JSON.parse(JSON.stringify(this.urlParts||[]));

  urlsconten = 'beequalto'
  targetingpOtions=  [
    { name: '等于', controls: 'beequalto' },
    { name: '包含', controls: 'contain' }
  ]

  urlsArr:any[] = []
  completeMatching = false

  created() {
    this.targetingInit()
  }
  targetingInit(){
    if (this.show) {
      return
    }
    if (this.beequaltoUrls.length > 0) {
      this.urlsArr = this.dataInit(this.beequaltoUrls)
      this.urlsconten ='beequalto'
      this.completeMatching = !!this.beequaltoUrls[0]?.completeMatching
      this.show = true
    }else if (this.containUrlParts.length > 0) {
      this.urlsArr = this.dataInit(this.containUrlParts)
      this.urlsconten = 'contain'
      this.show = true
    }else{
      this.show =false
    }
  }

  dataInit(val : any[]){
    let arr = []
    for (let i = 0; i < val.length; i++) {
      arr.push(val[i].url) 
    }
    return arr
  }


  changeShow(){
    if (!this.show) {
      this.beequaltoUrls = []
      this.containUrlParts = []
      this.urlsArr = []
    }
    this.changeBeequaltoUrls()
  }
  dataOptions(val : any[]){
    let arr = []
    let that = this
    for (let i = 0; i < val.length; i++) {
      arr.push({
        url: val[i],
        completeMatching: that.completeMatching 
      }) 
    }
    return arr

  }

  changeUrlsArr(){
      if (this.urlsconten === 'beequalto') {
        this.beequaltoUrls = this.dataOptions(this.urlsArr)
        this.containUrlParts = []
      }else{
        this.containUrlParts = this.dataOptions(this.urlsArr)
        this.beequaltoUrls =[]
        this.completeMatching = false
      }
      this.changeBeequaltoUrls()
  }

  changeBeequaltoUrls(){
    this.$emit('change',{
      url: this.beequaltoUrls,
      urlParts: this.containUrlParts
    })
  }

  valid(){
    if (this.show && this.urlsArr.length == 0) {
      console.log('valid')
      this.$message.warning(this.label+'为空,请输入')
      this.$nextTick(() => {
          const urlsEl: any = this.$refs.urls
          urlsEl.focus();
      })
      return false
    }
    return true
  }

  @Watch('urls')
  changeUrls(val:any){
    this.beequaltoUrls = JSON.parse(JSON.stringify(val))
    this.targetingInit()
  }
  @Watch('urlParts')
  changeurlParts(val:any){
    this.containUrlParts = JSON.parse(JSON.stringify(val))
    this.targetingInit()
  }
}
